import React from "react";
import { useLocalization } from "@i18n";
import { GS3HeaderLogo } from "@/assets/images";

const HomePage: React.FC = () => {
  const { translate } = useLocalization();

  return (
    <div className="h-full flex flex-col items-center justify-center px-8 text-center gap-4">
      <img
        src={GS3HeaderLogo}
        alt="GS3 Logo"
        className="h-12 object-contain"
      />
      <h1 className="text-h2 text-foreground font-bold">
        {translate("home.welcome.title")}
      </h1>
      <p className="text-body-large text-muted-foreground max-w-xl">
        {translate("home.welcome.subtitle")}
      </p>
    </div>
  );
};

export default HomePage;
